import { render, staticRenderFns } from "./invisible.vue?vue&type=template&id=45be0ce2&scoped=true&"
var script = {}
import style0 from "./invisible.vue?vue&type=style&index=0&id=45be0ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be0ce2",
  null
  
)

export default component.exports